import { useEffect } from "react";

// JSON-LD structured data for Google — LocalBusiness schema with both locations,
// services, and social profiles. Boosts local SEO for "personal trainer Scarborough"
// type searches and enables rich results (business info, ratings, hours).
export default function SchemaMarkup() {
  useEffect(() => {
    const siteUrl = "https://getfitwithjc.com";
    const logo = "https://customer-assets-eiarnc6j.emergentagent.net/job_bootcamp-gains/artifacts/5y2r1css_Jcfitness%20smile.jpg";

    const schema = {
      "@context": "https://schema.org",
      "@type": "HealthClub",
      "@id": `${siteUrl}#business`,
      name: "Getfitwithjeanclaude",
      alternateName: "Get Fit With Jean Claude",
      description:
        "Personal training, strength & conditioning, and high-energy bootcamps with Coach Jean Claude in Scarborough, Toronto. Build a body that wins.",
      url: siteUrl,
      logo,
      image: logo,
      telephone: "+1-647-513-2225",
      priceRange: "$$",
      currenciesAccepted: "CAD",
      paymentAccepted: "Credit Card, Debit Card, Afterpay",
      areaServed: [
        { "@type": "City", name: "Scarborough" },
        { "@type": "City", name: "Toronto" },
      ],
      sameAs: [
        "https://www.instagram.com/getfitwithjeanclaude",
      ],
      location: [
        {
          "@type": "Place",
          name: "Afterburn Performance",
          address: {
            "@type": "PostalAddress",
            streetAddress: "230 Nantucket Blvd #1",
            addressLocality: "Scarborough",
            addressRegion: "ON",
            postalCode: "M1P 2N9",
            addressCountry: "CA",
          },
        },
        {
          "@type": "Place",
          name: "Synergy Fitness",
          address: {
            "@type": "PostalAddress",
            streetAddress: "1703 Victoria Park Ave Unit 2",
            addressLocality: "Scarborough",
            addressRegion: "ON",
            postalCode: "M1R 1R9",
            addressCountry: "CA",
          },
        },
      ],
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Coaching Programs",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "In-Person Personal Training",
              description: "1-on-1 personal training sessions in Scarborough.",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hybrid Coaching",
              description: "Blend of in-person sessions and online programming.",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Online Coaching",
              description: "Fully remote strength & conditioning programming with check-ins.",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Unlimited Bootcamp",
              description: "Unlimited group bootcamp classes at both locations.",
            },
          },
        ],
      },
      founder: {
        "@type": "Person",
        name: "Jean Claude",
        jobTitle: "Personal Trainer & Strength Coach",
      },
    };

    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = JSON.stringify(schema);
    el.id = "ld-json-business";
    // Remove any prior copy (hot-reload safety)
    const prior = document.getElementById("ld-json-business");
    if (prior) prior.remove();
    document.head.appendChild(el);

    return () => {
      const node = document.getElementById("ld-json-business");
      if (node) node.remove();
    };
  }, []);

  return null;
}
